export const creditText = (songName: string, videoUrl: string) =>
  `Music: ${songName ? songName : "[Paste Artist - Track Title]"}` +
  "\n© Provided by Audio Sanctum" +
  `\nWatch: ${videoUrl ? videoUrl : "[Paste link to Audio Sanctum YT video]"}` +
  "\nListen: https://spotify.audiosanctum.com" +
  "\nBuy: https://sanctum.shop" +
  "\nFree Use Terms → https://audiosanctum.com/free-use";
